import { notification } from 'antd';

import { userRememberMeCookie } from './userRememberMeCookie';
import { store } from 'store';
import { AuthLogin } from 'shared/interfaces';
import { fetchStaticContent } from 'store/staticContent/action';
import { apiAuth } from 'utils/http/apiAuth';
import apiUser from 'utils/http/apiUser';
import { navigateTo } from 'utils/helpers';
import { staticContentStorage } from 'utils/staticContent/staticContentStorage';
import userStorage from 'utils/user/userStorage';

export const loginUser = async (values: AuthLogin) => {
  try {
    const authLoginBody = {
      application: process.env.REACT_APP_APPLICATION_ID,
      ...values,
    };
    const authResponse = await apiAuth.login(authLoginBody);

    userStorage.setToken(authResponse);

    const respCurrentUser = await apiUser.getCurrentUser();
    userStorage.setUser(respCurrentUser);
    await store.dispatch(fetchStaticContent());

    if (values.rememberMe) {
      userRememberMeCookie.set(values as AuthLogin);
    } else {
      userRememberMeCookie.remove();
    }
  } catch (e) {
    throw new Error(e.message);
  }
};

export const logoutUser = () => {
  apiAuth.logout();
  userStorage.removeUserAndToken();
  staticContentStorage.removeContent();
  navigateTo('/');
};

export const isUserAuth = () => {
  return Boolean(userStorage.getUser() && userStorage.getToken());
};

export const refreshUserAuth = async () => {
  try {
    const respToken = await apiAuth.refresh();
    userStorage.setToken(respToken);
  } catch (e) {
    logoutUser();
    notification.error({
      message: 'Error',
      description: e.message,
    });
  }
};

export const isUserAuthExpired = () => {
  const token = userStorage.getToken();

  if (token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const decodedToken = JSON.parse(window.atob(base64));

    return new Date(decodedToken.exp * 1000) < new Date();
  } else {
    return false;
  }
};
